import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "fitting"
    }}>{`Fitting`}</h1>
    <p>{`Options for fitting content to a frame.`}</p>
    <h2 {...{
      "id": "class"
    }}>{`Class`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`PROPORTIONAL`}</strong>{` = 1684885618`}</p>
      <p parentName="blockquote">{`Resizes content to fit the frame while preserving content proportions. If the content and frame have different proportions, some empty space occurs in the frame.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`FIT_CONTENT_TO_FRAME`}</strong>{` = 1684883043`}</p>
      <p parentName="blockquote">{`Resizes content to fit the frame. Note: Content that is a different size than the frame appears stretched or squeezed.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`FIT_FRAME_TO_CONTENT`}</strong>{` = 1684883046`}</p>
      <p parentName="blockquote">{`Resizes the frame to fit the content.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`PRESERVE_SIZES`}</strong>{` = 1684885619`}</p>
      <p parentName="blockquote">{`Preserves the original sizes of the frame and the content. Note: Content that is larger than the frame is obscured around the edges.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`CONTENT_AWARE_FITTING`}</strong>{` = 1684882241`}</p>
      <p parentName="blockquote">{`Selects best crop region of the content for the frame based on Adobe Sensei. Note: Preserves frame size but might scale the content size. If this fitting is set, centerImage property is turned-off.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`HONOUR_EXISTING_STYLE`}</strong>{` = 1684883539`}</p>
      <p parentName="blockquote">{`Apply the frame fitting based on existing setting applied on the orginal frame.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`FILL_PROPORTIONAL`}</strong>{` = 1684883056`}</p>
      <p parentName="blockquote">{`Resizes content to fill the frame while preserving content proportions. If the content and frame have different proportions, some content is obscured by the bounding box of the frame.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      